var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c(
        "div",
        {
          staticClass: "toggle-button toggle-loading",
          class: _vm.toggleClass,
          style: _vm.pillStyle
        },
        _vm._l(_vm.skeletonsCount, function(i) {
          return _c("BaseLoadingSkeleton", {
            key: "toggle-skeleton-" + i,
            staticClass: "toggle-skeleton-item",
            attrs: { width: _vm.skeletonWidth, height: _vm.skeletonHeight }
          })
        }),
        1
      )
    : _c(
        "v-btn-toggle",
        {
          staticClass: "toggle-button",
          class: _vm.toggleClass,
          style: _vm.pillStyle,
          attrs: {
            value: _vm.value,
            mandatory: !_vm.deselectable,
            dense: "",
            borderless: "",
            role: "group"
          },
          on: { change: _vm.handleChange }
        },
        [
          _vm._l(_vm.options, function(option) {
            return [
              option.icon && option.tooltip
                ? _c(
                    "v-tooltip",
                    {
                      key: "tooltip-" + option.value,
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        class: _vm.toggleClass,
                                        attrs: {
                                          small: "",
                                          value: option.value,
                                          "aria-pressed":
                                            _vm.ariaPressedPorValor[
                                              option.value
                                            ]
                                        }
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c("icon-svg", {
                                      attrs: {
                                        name: option.icon,
                                        size: _vm.iconSize,
                                        color: _vm.iconColor(option.value)
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [_c("span", [_vm._v(_vm._s(option.tooltip))])]
                  )
                : _c(
                    "v-btn",
                    {
                      key: "btn-" + option.value,
                      class: _vm.toggleClass,
                      attrs: {
                        small: "",
                        value: option.value,
                        "aria-pressed": _vm.ariaPressedPorValor[option.value]
                      }
                    },
                    [
                      option.icon
                        ? _c("icon-svg", {
                            attrs: {
                              name: option.icon,
                              size: _vm.iconSize,
                              color: _vm.iconColor(option.value)
                            }
                          })
                        : [
                            _vm._v(" " + _vm._s(option.text) + " "),
                            option.noAccessModule
                              ? _c("IconNoModuleAccess", {
                                  staticClass: "ml-2",
                                  attrs: {
                                    iconSize: "12",
                                    module: option.noAccessModule
                                  }
                                })
                              : _vm._e()
                          ]
                    ],
                    2
                  )
            ]
          })
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }